"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityCreateDialog = exports.EntityCreateDialogDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var dialog_1 = require("../elements/dialog");
var icon_button_1 = require("../elements/icon-button");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var use_lang_1 = require("../../hooks/use-lang");
var sprintf_js_1 = require("sprintf-js");
var entity_duplicate_layout_1 = require("./entity-duplicate-layout");
var client_1 = require("@apollo/client");
var lodash_1 = require("lodash");
var use_entities_1 = require("../../hooks/use-entities");
var use_form_1 = require("../../v2/hooks/use-form");
var form_v2_1 = require("../../v2/elements/form-v2");
exports.EntityCreateDialogDefaultProps = {
  variant: 'default',
  onComplete: function () {},
  onCancel: function () {}
};
// -------- Styles -------->
var DialogStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    text-align: left;\n  "], ["\n    text-align: left;\n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    box-sizing: border-box;\n  "], ["\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    box-sizing: border-box;\n  "])))
});
var ControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    padding: ", " ", " ", " ;\n    background: ", ";\n    border-top: 1px solid ", ";\n  "], ["\n    display: flex;\n    justify-content: center;\n    padding: ", " ", " ", " ;\n    background: ", ";\n    border-top: 1px solid ", ";\n  "])), theme_1.theme.UNIT(4.5), theme_1.theme.UNIT(5), theme_1.theme.UNIT(5), theme_1.theme.COLOR('app-chrome'), theme_1.theme.COLOR('line-subtle'))
});
var CancelButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ContinueButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var CreateButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LinkButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var DuplicateLayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var FormStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    line-height: 1.0em;\n    padding: ", ";\n    box-sizing: border-box;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    line-height: 1.0em;\n    padding: ", ";\n    box-sizing: border-box;\n  "])), theme_1.theme.UNIT(4))
});
var SelectStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var FieldStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
// -------- Components -------->
var My = {
  Dialog: (0, styled_components_1.default)(dialog_1.Dialog)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), DialogStyles),
  Body: styled_components_1.default.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Controls: styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles),
  CancelButton: (0, styled_components_1.default)(icon_button_1.CloseIconButton)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), CancelButtonStyles),
  CreateButton: (0, styled_components_1.default)(icon_button_1.SubmitIconButton)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), CreateButtonStyles),
  ContinueButton: (0, styled_components_1.default)(icon_button_1.ContinueIconButton)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ContinueButtonStyles),
  LinkButton: (0, styled_components_1.default)(icon_button_1.IconButton)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), LinkButtonStyles),
  Form: (0, styled_components_1.default)(form_v2_1.FormV2)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), FormStyles),
  DuplicateLayout: (0, styled_components_1.default)(entity_duplicate_layout_1.EntityDuplicateLayout)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), DuplicateLayoutStyles)
};
var EntityCreateDialog = function (props) {
  var _a, _b;
  var className = props.className,
    entityTypeName = props.entityTypeName,
    variant = props.variant,
    onCancel = props.onCancel,
    onComplete = props.onComplete;
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  if (!definition) {
    throw new Error("No entity definition found for entity type name: ".concat(entityTypeName));
  }
  var config = definition.duplicateDialogConfig;
  var t = (0, use_lang_1.useLang)();
  var formName = "create_".concat(entityTypeName);
  var form = (0, use_form_1.useForm)(formName);
  var entities = (0, use_entities_1.useEntities)();
  var _c = __read((0, react_1.useState)(false), 2),
    needsConfirmation = _c[0],
    setNeedsConfirmation = _c[1];
  var _d = __read((0, client_1.useLazyQuery)(definition.namedQuery, {
      fetchPolicy: 'network-only'
    }), 2),
    entityNamed = _d[0],
    _e = _d[1],
    nameCheckLoading = _e.loading,
    nameCheckData = _e.data;
  var items = nameCheckData === null || nameCheckData === void 0 ? void 0 : nameCheckData["".concat(definition.leadingPluralTypeName, "Named")];
  var _f = __read((0, client_1.useMutation)(definition.create.mutation, {
      onError: function (error) {
        throw new Error(error.message);
      }
    }), 2),
    mutation = _f[0],
    waiting = _f[1].loading;
  // definition.useDuplicateCheck && checkForDuplicates
  // listen out for entity duplicate checks
  react_1.default.useEffect(function () {
    if (nameCheckData) {
      var items_1 = nameCheckData["".concat(definition.leadingPluralTypeName, "Named")];
      if (items_1 && items_1.length) {
        var shouldConfirm = definition.shouldConfirmDuplicates({
          formFields: form.fields,
          duplicates: items_1
        });
        if (shouldConfirm) {
          setNeedsConfirmation(true);
        }
      }
    }
  }, [nameCheckLoading, nameCheckData]);
  var cancel = function () {
    form.reset();
    if (props.onCancel) {
      props.onCancel();
    }
  };
  var performMutation = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        // const result = await mutation({ variables: { name: formState.name } });
        onComplete();
        return [2 /*return*/];
      });
    });
  };
  var handleContinueClick = function (e) {
    performMutation();
  };
  var onFormEscape = function () {
    cancel();
  };
  var handleFormSubmit = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!definition.useDuplicateCheck) return [3 /*break*/, 1];
            // kick off the entityNamed query to run the duplicates check
            entityNamed({
              variables: {
                name: (_a = form.fields.name) === null || _a === void 0 ? void 0 : _a.value
              }
            });
            return [3 /*break*/, 3];
          case 1:
            return [4 /*yield*/, performMutation()];
          case 2:
            _b.sent();
            _b.label = 3;
          case 3:
            return [2 /*return*/];
        }
      });
    });
  };
  var handleCancelClick = function (e) {
    cancel();
  };
  var handleNameChange = function (result) {
    setNeedsConfirmation(false);
  };
  // this could be moved to an entity form
  var handleNameBlur = function (result) {
    var _a, _b;
    var name = ((_a = form.fields.name) === null || _a === void 0 ? void 0 : _a.value) || '';
    if (definition.useSiteSlug && name && !(0, lodash_1.trim)(((_b = form.fields.siteSlug) === null || _b === void 0 ? void 0 : _b.value) || '')) {
      var siteSlugValue = (0, lodash_1.kebabCase)(name);
      form.patchFields({
        siteSlug: {
          value: siteSlugValue
        }
      });
    }
  };
  var handleSiteSlugBlur = function (result) {
    var _a, _b;
    if (definition.useSiteSlug) {
      var currentValue = ((_a = form.fields.siteSlug) === null || _a === void 0 ? void 0 : _a.value) || '';
      var currentName = ((_b = form.fields.name) === null || _b === void 0 ? void 0 : _b.value) || '';
      if (!currentValue) {
        form.patchFields({
          siteSlug: {
            value: (0, lodash_1.kebabCase)(currentName)
          }
        });
      } else {
        var correctValue = (0, lodash_1.kebabCase)(currentValue);
        if (correctValue !== currentValue) {
          form.patchFields({
            siteSlug: {
              value: correctValue
            }
          });
        }
      }
    }
  };
  var strings = (0, react_1.useMemo)(function () {
    return {
      createLabel: t(definition.create.label),
      continueLabel: (0, sprintf_js_1.sprintf)(t(config.continueLabel), definition.label),
      cancelLabel: (0, sprintf_js_1.sprintf)(t(config.cancelLabel), definition.label),
      title: t(definition.create.newLabel)
    };
  }, [entityTypeName, variant]);
  var FIELDS = (0, lodash_1.filter)([{
    name: 'name',
    label: 'Name',
    description: (0, sprintf_js_1.sprintf)(t('First, please provide a name for this %s.'), definition.label, definition.label),
    required: true,
    autoFocus: true,
    onChange: handleNameChange,
    onBlur: handleNameBlur,
    type: 'text'
  }, definition.useSites && {
    name: 'sites',
    label: entities.Site.pluralLabel,
    description: "Which {{SITES}} can this ".concat(definition.label, " appear in?<br><br>Note: this does not automatically setup a {{SITE}}, it's used to identify which {{SITES}} may include this ").concat(definition.label, ". This can be changed later if you are unsure."),
    type: 'linkedMultiple',
    entityTypeName: 'Site'
  }, definition.useSiteSlug && {
    name: 'siteSlug',
    label: 'Website Slug',
    description: "This is the part of the URL which uniquely identifies this ".concat(definition.label, " in a website, and should be a lower-case version of the name field with words separated by dashes."),
    onBlur: handleSiteSlugBlur,
    type: 'text',
    entityTypeName: 'Site'
  }]);
  var canCancel = !nameCheckLoading && !waiting;
  return react_1.default.createElement(My.Dialog, {
    padBody: false,
    title: strings.title,
    className: className,
    isCancelButtonDisabled: !canCancel,
    onCancel: handleCancelClick,
    controls: react_1.default.createElement(My.Controls, null, needsConfirmation && react_1.default.createElement(My.ContinueButton, {
      onClick: handleContinueClick
    }, strings.continueLabel), !needsConfirmation && react_1.default.createElement(My.CreateButton, {
      disabled: !(0, lodash_1.trim)((_a = form.fields.name) === null || _a === void 0 ? void 0 : _a.value),
      onClick: function () {
        handleFormSubmit();
      }
    }, t((0, sprintf_js_1.sprintf)('Create %s', definition.label))))
  }, react_1.default.createElement(My.Body, null, react_1.default.createElement(My.Form, {
    name: formName,
    onSubmit: function () {
      handleFormSubmit();
    },
    onEscape: onFormEscape,
    fields: FIELDS
  }), needsConfirmation && react_1.default.createElement(My.DuplicateLayout, {
    name: (_b = form.fields.name) === null || _b === void 0 ? void 0 : _b.value,
    entityTypeName: entityTypeName,
    items: items,
    variant: variant
  })));
};
exports.EntityCreateDialog = EntityCreateDialog;
exports.EntityCreateDialog.defaultProps = exports.EntityCreateDialogDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20;